/** Limite alinhado com BulkLayerFileRequest / ImageUpdateRequest (KB no Laravel). */
export const MAX_FILE_SIZE_KB = 512000

export const MAX_BULK_FILE_COUNT = 500

export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_KB * 1024

export const ALLOWED_IMAGE_TYPES = [
    'image/png',
    'image/jpeg',
    'image/jpg',
    'image/webp',
    'image/gif',
]

export const ALLOWED_DOCUMENT_TYPES = [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'text/plain',
]

export const ACCEPT_IMAGES = 'image/png,image/jpeg,image/jpg,image/webp,image/gif'

export const ACCEPT_DOCUMENTS = '.pdf,.doc,.docx,.xls,.xlsx,.txt'

export const ACCEPT_ZIP = '.zip,application/zip'

export const ACCEPT_RAR = '.rar,application/x-rar-compressed,application/vnd.rar'

export const ACCEPT_COMPRESSED = `${ACCEPT_ZIP},${ACCEPT_RAR}`

const ALLOWED_ZIP_MIMES = [
    'application/zip',
    'application/x-zip-compressed',
    'application/zip-compressed',
    'multipart/x-zip',
]

const ALLOWED_RAR_MIMES = [
    'application/x-rar-compressed',
    'application/vnd.rar',
    'application/x-compressed',
    'application/octet-stream',
]

export function getAcceptForType(addType) {
    return addType === 'imagens' ? ACCEPT_IMAGES : ACCEPT_DOCUMENTS
}

export const ACCEPT_BULK = `${ACCEPT_IMAGES},${ACCEPT_DOCUMENTS}`

export function getAcceptForBulk() {
    return ACCEPT_BULK
}

export function resolveStorageTypeFromName(name = '') {
    const ext = (name.split('.').pop() || '').toLowerCase()
    if (['png', 'jpg', 'jpeg', 'webp', 'gif'].includes(ext)) return 'imagens'
    if (['pdf', 'doc', 'docx', 'xls', 'xlsx', 'txt'].includes(ext)) return 'documentos'
    return null
}

export function validateBulkFileMime(mime = '', name = '') {
    if (mime && (ALLOWED_IMAGE_TYPES.includes(mime) || ALLOWED_DOCUMENT_TYPES.includes(mime))) {
        return { ok: true, message: '' }
    }
    if (resolveStorageTypeFromName(name)) {
        return { ok: true, message: '' }
    }
    return {
        ok: false,
        message: 'O arquivo adicionado não está em uma extensão permitida (imagem ou documento).',
    }
}

export function isImagePath(path = '') {
    return /\.(png|jpg|jpeg|webp|gif)$/i.test(path)
}

export function isPdfPath(path = '') {
    return /\.pdf$/i.test(path)
}

function isZipPath(path = '') {
    return /\.zip$/i.test(path)
}

function isRarPath(path = '') {
    return /\.rar$/i.test(path)
}

export function isCompressedPath(path = '') {
    return isZipPath(path) || isRarPath(path)
}

export function getAcceptForCompressed() {
    return ACCEPT_COMPRESSED
}

export function archiveTypeLabel(name = '') {
    const ext = (name.split('.').pop() || '').toLowerCase()
    if (['png', 'jpg', 'jpeg', 'webp', 'gif'].includes(ext)) return 'Imagem'
    if (ext === 'pdf') return 'PDF'
    if (['doc', 'docx'].includes(ext)) return 'Documento'
    if (['xls', 'xlsx'].includes(ext)) return 'Planilha'
    if (ext === 'txt') return 'Texto'
    if (ext === 'zip') return 'ZIP'
    if (ext === 'rar') return 'RAR'
    return 'Arquivo'
}

export function validateFileMime(addType, mime = '') {
    if (addType === 'documentos' && !ALLOWED_DOCUMENT_TYPES.includes(mime)) {
        return {
            ok: false,
            message: 'O documento adicionado não está na extensão correta.',
        }
    }
    if (addType === 'imagens' && !ALLOWED_IMAGE_TYPES.includes(mime)) {
        return {
            ok: false,
            message: 'A imagem adicionada não está na extensão correta.',
        }
    }
    return { ok: true, message: '' }
}

export function validateFileSize(file) {
    if (!file || file.size > MAX_FILE_SIZE_BYTES) {
        return {
            ok: false,
            message: 'O arquivo excede o tamanho máximo permitido.',
        }
    }
    return { ok: true, message: '' }
}

export function validateCompressedFile(file) {
    if (!file) {
        return { ok: false, message: 'Nenhum arquivo compactado selecionado.' }
    }

    const name = file.name || ''
    const mime = file.type || ''

    if (!isCompressedPath(name)) {
        return { ok: false, message: 'O arquivo deve ser compactado (.zip ou .rar).' }
    }

    if (isZipPath(name) && mime && !ALLOWED_ZIP_MIMES.includes(mime)) {
        return { ok: false, message: 'O arquivo selecionado não é um ZIP válido.' }
    }

    if (isRarPath(name) && mime && !ALLOWED_RAR_MIMES.includes(mime) && !ALLOWED_ZIP_MIMES.includes(mime)) {
        return { ok: false, message: 'O arquivo selecionado não é um RAR válido.' }
    }

    const sizeCheck = validateFileSize(file)
    if (!sizeCheck.ok) {
        return { ok: false, message: 'O arquivo compactado excede o tamanho máximo permitido.' }
    }

    return { ok: true, message: '' }
}

/** @deprecated Use validateCompressedFile */
export function validateZipFile(file) {
    return validateCompressedFile(file)
}

export function createPendingUploadItem(raw) {
    const file = raw?.originFileObj ?? raw
    return {
        uid: `pending-${Date.now()}-${Math.random().toString(36).slice(2)}`,
        name: file?.name ?? raw?.name ?? '',
        raw: file,
        previewUrl: URL.createObjectURL(file),
    }
}

export function revokePreviewUrls(items = []) {
    items.forEach((item) => {
        if (item?.previewUrl) {
            URL.revokeObjectURL(item.previewUrl)
        }
    })
}
